import React from 'react';

import styles from './VerticalDelimiter.scss';

function VerticalDelimiter({ margin = 25 }) {
  return <div className={styles.verticalDelimiter} style={{ margin: `${margin}px auto` }} />;
}

export default VerticalDelimiter;
